export const MB = 1024 * 1024;
export const MAX_FILE_SIZE = 8 * MB;
export const MAX_FILES = 6;
